import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IRequirementMast } from "../../../models/RequirementMast";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { useEffect, useRef, useState } from "react";
import { ICityMastDropdown, IClientCompanyDropdown, ICountryMastDropdown, IStateMastDropdown, IUniversityDropdown, IVisaDropdown } from "../../../models/IDropdown";
import { useForm } from "react-hook-form";
import { JVDropdownInput } from "../../../shared/JVDropdownInput";
import { JVInput } from "../../../shared/JVInput";
import { JVDropdown } from "../../../shared/JVDropdown";
import { JVRadioBtn } from "../../../shared/JVRadioBtn";
import { EmptySubmission } from "../EmptySubmission";
import { NoticePeriod, Experience, Tax_Term, MatchingPer, Submission_Type } from "../../../models/FDropdown";
import { IConsultantMast, TaxTerm } from "../../../models/ConsultantMast";
import { AutoComplete } from "primereact/autocomplete";
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from "primereact/inputtext";
import { Req } from "../../../shared/Req";
import { JVInputMask } from "../../../shared/JVInputMask";
import { Resumes } from "./Resumes";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { VendorCompanyHistoryTable } from "./SubVendorReportHistory";
import { ILogin } from "../../../models/Login";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";

interface Iprops {
    recruiter?: string,
    submission_id?: number,
    req_id?: number,
    cons_id?: number,
    vendor_Company_ID?: number,
    status?: number,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    hideDialogP: () => void,
    recruiterID: number,
}

export const Submission = (props: Iprops) => {
    const [reject, setReject] = useState({ subrate: 0, isReject: false, reason: "" });
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<IRequirementMast>();
    const [additionInfo, setAdditionInfo] = useState("");
    const [vendorCompHitory, setVendorCompHitory] = useState({ open: false, companyName: '', recruiter: props.recruiterID } as { open: boolean, companyName: string, recruiter: number });
    const [supportiveDoc, setSupportiveDoc] = useState<File | any | null>(null);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const [resume, setResume] = useState({ open: false } as
        {
            vendor_Company_ID?: number,
            cons_id?: number,
            open: boolean
        });

    const hideDialog = () => {
        setResume({ open: false });
    };

    useEffect(() => {
        if (props.vendor_Company_ID && props.cons_id) setResume({
            vendor_Company_ID: props.vendor_Company_ID,
            cons_id: props.cons_id,
            open: true
        });
    }, [props.vendor_Company_ID, props.cons_id]);

    useEffect(() => {
        if (props.req_id) loadData();
    }, [props.req_id]);

    const loadData = async () => {
        const response = await Fetch("Requirement_MAST/byId", "GET", null, `req_id=${props.req_id}`, props.toast);
        if (response) {
            const data: IRequirementMast = await response.json();
            setData(data);
        }
    }

    const [cities, setCities] = useState<Array<ICityMastDropdown>>();
    const [states, setStates] = useState<Array<IStateMastDropdown>>();
    const [countries, setCountries] = useState<Array<ICountryMastDropdown>>();
    const [visa, setVisa] = useState<Array<IVisaDropdown>>();
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [universities, setUniversities] = useState<Array<IUniversityDropdown>>();
    const [university, setUniversity] = useState<IUniversityDropdown | undefined | string>(undefined);
    const [rejectedByPVReasondDropDownRows, setRejectedByPVReasondDropDownRows] = useState([]);

    const { control, formState: { errors }, reset, setValue } = useForm<IConsultantMast & { rejection_Reason_Status?: string | null }>({
        defaultValues: { ...EmptySubmission, rejection_Reason_Status: null },
        shouldFocusError: false
    });

    useEffect(() => {
        if (university) {
            let un: string | undefined = undefined;
            if (typeof (university) === 'string') {
                un = university;
            } else {
                un = university?.university_Name;
            }
            setValue("university_Name", un);
        } else {
            setValue("university_Name", undefined);
        }
    }, [university]);

    useEffect(() => {
        if (props.submission_id) fillSub();
    }, [props.submission_id]);

    const loadCities = async (filter: string | null) => {
        const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<ICityMastDropdown> = await response.json();
            setCities(data);
        }
    }
    const completeMethodCities = (event: { query: string }) => {
        loadCities(event.query);
    }

    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            setStates(data);
        }
    }
    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    }

    const loadCountries = async (filter: string | null) => {
        const response = await Fetch("Dropdown/countries", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<ICountryMastDropdown> = await response.json();
            setCountries(data);
        }
    }
    const completeMethodCountries = (event: { query: string }) => {
        loadCountries(event.query);
    }

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }
    const completeMethodEC = (event: { query: string }) => {
        loadClientCompanies(event.query);
    }

    const loadVisa = async () => {
        const response = await Fetch("Dropdown/visa", "GET", null, null, null);
        if (response) {
            const data: Array<IVisaDropdown> = await response.json();
            setVisa(data);
        }
    }

    const loadUniversities = async (filter: string | null) => {
        const response = await Fetch("Dropdown/universities", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IUniversityDropdown> = await response.json();
            setUniversities(data);
        }
    }
    const completeMethodUniversities = (event: { query: string }) => {
        loadUniversities(event.query);
    }

    // const RejectReasondDropDownRows = [
    //     {name: '-- SELECT --', value: 0},
    //     {name: 'Testing 1', value: 1},
    //     {name: 'Testing 2', value: 2},
    //     {name: 'Testing 3', value: 3},
    //     {name: 'Testing 4', value: 4},
    //     {name: 'Testing 5', value: 5},
    // ];

    async function LoadSubRejectionCategory(name: string) {
        const response = await Fetch("Pipeline_Status_Mast/getSubCategoryListing", "GET", null, `ssn=${name}`, props.toast);
        if (response) {
            const data = await response.json();
            setRejectedByPVReasondDropDownRows(data);
        }
    };

    useEffect(() => {
        LoadSubRejectionCategory("Rejected by Sales Manager");
    }, [reject.isReject]);

    useEffect(() => {
        setValue("rejection_Reason_Status", null);
        loadVisa();
    }, []);

    const fillSub = async () => {
        setLoading(true);
        setUniversity(undefined);

        const response = await Fetch("Consultant_Mast/submission", "GET", null, `submission_id=${props.submission_id}`, props.toast);
        if (response) {
            const data: IConsultantMast = await response.json();
            reset(data);
            setValue("identity", data.consultant_Email_ID);
            setValue("state", { state_ID: 1, state_Name: data.consultant_State });
            setValue("city", { city_ID: data.consultant_City, city_Name: data.city_Name });
            setValue("country", { country_ID: data.consultant_Country, country_Name: data.country_Name });
            setValue("company", { vendor_Company_ID: data.vendor_Company_ID, vendor_Company_Name: data.vendor_Company_Name });
            setValue("concent", data.concent);
            setValue("mathingProfilePer", data.mathingProfilePer);
            setValue("faceToFaceInterview", false);
            setValue("tax_Term", TaxTerm.C2C_With_Benefits);
            setUniversity({ university_ID: data.university_ID, university_Name: data.university_Name });
            if (data.addition_Info) setAdditionInfo(data.addition_Info);
            if (props.status && data.submittal_Rate) setReject({ subrate: data.submittal_Rate, isReject: reject.isReject, reason: reject.reason })
        }
        setLoading(false);
    }

    const saveToDB = async () => {
        setLoading(true);
        const formData = new FormData();
        if (reject.isReject) {
            // if (supportiveDoc === null) {
            //     props.toast.current.show({ severity: 'error', detail: 'Rejection Reason Reference File is required', life: 3000 });
            // } else 
            if (reject.reason.length < 1) {
                props.toast.current.show({ severity: 'error', detail: 'write the reason of rejection!', life: 3000 });
            } else if (!control._formValues.rejection_Reason_Status || control._formValues.rejection_Reason_Status === null || control._formValues.rejection_Reason_Status === "") props.toast.current.show({ severity: 'error', detail: 'select status of rejection!', life: 3000 });
            else {
                const newBody = {
                    req_id: props.req_id,
                    cons_id: props.cons_id,
                    buyrate: control._formValues.buying_Rate,
                    subrate: 0,
                    accepted: !reject.isReject,
                    reason: reject.reason,
                    rejection_Reason_Status: control._formValues.rejection_Reason_Status,
                };

                formData.append("spDoc", supportiveDoc);
                formData.append("body", JSON.stringify(newBody));

                const params = {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
                    },
                    body: formData,
                };

                const response = await fetch(`${baseUrl}Requirement_MAST/reqService`, params);
                // const response = await Fetch("Requirement_MAST/reqService", "POST", null, `req_id=${props.req_id}&cons_id=${props.cons_id}&buyrate=${control._formValues.hourly_Rate}&subrate=${0}&accepted=${!reject.isReject}&reason=${reject.reason}${control._formValues.rejection_Reason_Status !== null ? `&rejection_Reason_Status=${control._formValues.rejection_Reason_Status}` : ''}`, props.toast);
                if (response.ok) {
                    props.toast.current.show({ severity: 'success', summary: 'Success', detail: 'Rejected Successfull!', life: 3000 });
                    setValue("rejection_Reason_Status", null);
                    setSupportiveDoc(null);
                    props.hideDialogP();
                    props.setReload(!props.reload);
                    onHide();
                }
                if (response.status === 404 || response.status === 400) {
                    const message = await response.text();
                    props.toast.current.show({ severity: "error", detail: message, life: 3000 });
                }
            }
        } else {
            if (reject.subrate < 1) {
                props.toast.current.show({ severity: 'error', detail: 'Fill the Submission Rate.', life: 3000 });
            } else if (reject.subrate < control._formValues.buying_Rate) {
                props.toast.current.show({ severity: 'error', detail: 'Submission Rate should be greater than Buying Rate.', life: 3000 });
            } else if (!control._formValues.concent) {
                props.toast.current.show({ severity: 'error', detail: 'Please select Consent.', life: 3000 });
            } else if (!control._formValues.mathingProfilePer) {
                props.toast.current.show({ severity: 'error', detail: 'Please select Matching Profile Percentage.', life: 3000 });
            }
            else {
                const newBody = {
                    req_id: props.req_id,
                    cons_id: props.cons_id,
                    buyrate: control._formValues.buying_Rate,
                    subrate: reject.subrate,
                    concent: control._formValues.concent,
                    mathingProfilePer: control._formValues.mathingProfilePer,
                    accepted: !reject.isReject,
                };

                formData.append("body", JSON.stringify(newBody));

                const params = {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
                    },
                    body: formData,
                };

                const response = await fetch(`${baseUrl}Requirement_MAST/reqService`, params);

                // const response = await Fetch("Requirement_MAST/reqService", "POST", null, `req_id=${props.req_id}&cons_id=${props.cons_id}&buyrate=${control._formValues.hourly_Rate}&subrate=${reject.subrate}
                //     &concent=${control._formValues.concent}&mathingProfilePer=${control._formValues.mathingProfilePer}&accepted=${!reject.isReject}`, props.toast);
                if (response.ok) {
                    props.toast.current.show({ severity: 'success', summary: 'Success', detail: 'Accepted Successfull!', life: 3000 });
                    props.hideDialogP();
                    props.setReload(!props.reload);
                    onHide();
                }
                if (response.status === 404 || response.status === 400) {
                    const message = await response.text();
                    props.toast.current.show({ severity: "error", detail: message, life: 3000 });
                }
            }
            setSupportiveDoc(null);
        }
        setLoading(false);
    }

    const onHide = () => {
        setSupportiveDoc(null);
        props.hideDialog();
        reset(EmptySubmission);
        setReject({ subrate: 0, isReject: false, reason: "" });
    }

    const dFooter = () => {
        return (<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
            <Button loading={loading} className="p-button-sm my-1" form="submissionForm" label={reject.isReject ? "OK" : "ACCEPT"} onClick={saveToDB} type="button"></Button>
            {!reject.isReject && <Button className="p-button-sm p-button-danger my-1" label="REJECT" onClick={() => setReject((r) => ({ ...r, isReject: true }))} type="button"></Button>}
        </div>);
    }

    const OpenVendorHistoryTabe = () => {
        // if (data?.vendor_Company_Name) {
        //     setVendorCompHitory(true);
        // } else setVendorCompHitory(false);
        // const LoadRecruiter=()=>{};
        if (control._formValues.company?.vendor_Company_Name && props.recruiterID) {
            setVendorCompHitory({ open: true, companyName: control._formValues.company?.vendor_Company_Name, recruiter: props.recruiterID });
        } else setVendorCompHitory({ open: false, companyName: "", recruiter: 0 });
    }
    const HideVendorHistoryTabe = () => {
        setVendorCompHitory({ open: false, companyName: "", recruiter: 0 });
    }

    const fileUploade = async (event: FileUploadHandlerParam) => {
        if (event.files[0].size > 1024000) {
            props.toast.current.show({ severity: "error", content: "Document should be less than 2 MB." });
            event.options.clear();
        } else {
            props.toast.current.show({ severity: "success", content: "Document Selected." });
            const file = event.files[0];
            setSupportiveDoc(file);
            event.options.clear();
        }
    };

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Submit Consultant" footer={props.status ? "" : dFooter} className="p-fluid" draggable={false} onHide={onHide}>
            {data && <Req req={data} />}
            {!reject.isReject && <form id="submissionForm" className="p-fluid formgrid grid">

                <h3 style={{ margin: '10px 1vw 0px 1vw', width: '100%' }}>{props.recruiter}</h3>
                <div style={{ margin: '10px 1vw', width: '100%', fontWeight: 'bold' }}>Consultant Required Details:</div>

                <JVInput disabled placeholder="Consultant Name" column={3} control={control} name="consultant_Name" />
                <JVInput disabled placeholder="Enter Email" column={3} control={control} name="consultant_Email_ID" />
                <JVInputMask disabled required mask="(999) 999-9999" column={3} placeholder="Enter Phone" control={control} name="consultant_Home_No" error={errors.consultant_Home_No?.message} />
                <JVInput disabled placeholder="Enter Job Title" column={3} control={control} name="consultant_Job_Title" />

                <JVDropdown disabled column={3} control={control} name="visa_Status" options={visa} optionLabel="visa_Name" optionValue="visaId" placeholder="--Select Visa--" />
                <JVDropdownInput disabled column={3} completeMethod={completeMethodStates} control={control} name="state" options={states} optionLabel="state_Name" placeholder="Search State" />
                <JVDropdownInput disabled column={3} completeMethod={completeMethodCities} control={control} name="city" options={cities} optionLabel="city_Name" placeholder="Search City" />
                <JVDropdown disabled column={3} control={control} name="total_Experience" options={Experience} optionLabel="name" optionValue="name" placeholder="--Select Total Exp--" />

                <JVDropdown disabled column={3} control={control} name="availability" options={NoticePeriod} optionLabel="name" optionValue="value" placeholder="--Select NoticePeriod--" />
                <JVRadioBtn inline label="F2F Interview" disabled data={[{ label: "Yes", value: true }, { label: "No", value: false }]} column={3} control={control} name="faceToFaceInterview" />
                <JVInput disabled={props.status ? true : false} placeholder="Buying Rate" type={"number"} column={3} control={control} name="buying_Rate" />

                <div className="field col-12 md:col-4">
                    <InputText placeholder="Submission Rate" disabled={props.status ? true : false} value={reject.subrate} onChange={(e) => setReject({ isReject: reject.isReject, reason: reject.reason, subrate: Number(e.target.value) })} type='number' name="sub_Rate" />
                </div>
                <JVRadioBtn inline label="Consent" disabled={!!props.status} data={[{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }]} column={3} control={control} name="concent" />

                <JVDropdown disabled={!!props.status} column={3} control={control} name="mathingProfilePer" options={MatchingPer} optionLabel="name" optionValue="name" placeholder="--Select Matching Profile Percentage--" />
                <JVDropdown disabled column={3} control={control} name="tax_Term" options={Tax_Term} optionLabel="name" optionValue="id" placeholder="--Select TaxTerm--" />

                {/* <div style={{ margin: '10px 1vw', width: '100%', fontWeight: 'bold' }} className="flex flex-column-reverse align-content-start"><p>Other Consultant Details:</p> <div className="field col-12 md:col-4 flex align-items-center" onClick={() => OpenVendorHistoryTabe()} style={data?.vendor_Company_Name ? { color: "#2977ff", textDecoration: "underline", cursor: 'pointer' } : { color: '#adacac' }}><p>{data?.vendor_Company_Name}</p></div></div> */}
                <div className="field col-12 md:col-4 flex align-items-center" onClick={() => OpenVendorHistoryTabe()} style={(control._formValues.company?.vendor_Company_Name && control._formValues.company?.vendor_Company_Name?.length > 0) ? { color: "#2977ff", textDecoration: "underline", cursor: 'pointer' } : { color: '#adacac' }}><p>View Employer's Detail</p></div>
                <div style={{ margin: '10px 1vw', width: '100%', fontWeight: 'bold' }}>Other Consultant Details:</div>
                {/* <div className="field col-12 md:col-4 flex align-items-center" onClick={() => OpenVendorHistoryTabe()} style={data?.vendor_Company_Name ? { color: "#2977ff", textDecoration: "underline", cursor: 'pointer' } : { color: '#adacac' }}><p>{data?.vendor_Company_Name}</p></div> */}

                {/* <JVDate disabled placeholder="Date Of Birth" column={3} control={control} name="dob" /> */}
                <JVInput disabled placeholder="Date Of Birth" column={3} control={control} name="dob" />
                <JVInput disabled placeholder="Enter Degree" column={3} control={control} name="degree" />
                <JVInput disabled placeholder="Employer Email" column={3} control={control} name="contact_Person_EmailID" />

                <JVInput disabled placeholder="Enter SSN" column={3} type={"number"} control={control} name="ssn" />
                <JVDropdownInput disabled column={3} completeMethod={completeMethodCountries} control={control} name="country" options={countries} optionLabel="country_Name" placeholder="Search Country" />
                <JVDropdownInput disabled column={3} completeMethod={completeMethodEC} control={control} name="company" options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Employer Company" />

                <JVDropdown disabled column={3} control={control} name="submissionType" options={Submission_Type} optionLabel="name" optionValue="id" placeholder="--Select JobType--" />
                {/* <JVInput column={3} control={control} name="universityName" error={errors.universityName?.message} placeholder="University"/> */}

                <div className="field col-12 md:col-4">
                    <div className="p-inputgroup">
                        <AutoComplete disabled suggestions={universities}
                            completeMethod={completeMethodUniversities} field='university_Name' value={university}
                            placeholder="Search/Type University" onChange={(e) => setUniversity(e.value)} />
                    </div>
                </div>

                <JVInput disabled placeholder="Enter Contact Name" column={3} control={control} name="contact_Person_Name" />

                <JVInput disabled placeholder="Enter Salary" type={"number"} column={3} control={control} name="annual_Salary" />
                <JVInput disabled placeholder="Enter Passing Year" column={3} control={control} name="passoutYear" />
                <JVInputMask disabled required mask="(999) 999-9999" column={3} placeholder="Employer Phone" control={control} name="phone_No" error={errors.phone_No?.message} />
                {additionInfo.length > 0 && <div className="col-12 md:col-12 md:col-6">
                    <CKEditor disabled editor={ClassicEditor} data={additionInfo} onChange={(event, editor) => { setAdditionInfo(editor.getData()); }} />
                </div>}
            </form>}
            {reject.isReject && <div className="p-fluid formgrid grid" style={{ margin: '8px', marginTop: '20px', marginBottom: '0px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                <div style={{ width: '100%', marginLeft: '-15px' }}><JVDropdown column={3} label="Reason Status" required={true} control={control} name="rejection_Reason_Status" options={rejectedByPVReasondDropDownRows} optionLabel="sub_Status_Name" optionValue="sub_Status_Name" placeholder="Select Rejection Reason" error={errors.rejection_Reason_Status?.message} /></div>
                <div className="field col-12 md:col-6">
                    <label htmlFor="file">Rejection Supportive File (can be of any type audio, image, pdf, doc)</label>
                    <FileUpload chooseLabel="Choose File" mode="basic" name="file" accept="*" maxFileSize={10000000} auto customUpload uploadHandler={fileUploade} />
                </div>
                <label htmlFor="reason"> Reason : </label>
                <InputTextarea name="reason" placeholder="write the reason of rejection!" value={reject.reason} onChange={(e) => setReject((r) => ({ ...r, reason: e.target.value }))} rows={5} cols={30} maxLength={300} autoResize />
            </div>}
            <Resumes vendor_Company_ID={resume.vendor_Company_ID} cons_id={resume.cons_id} open={resume.open} hideDialog={hideDialog} toast={props.toast} />
            <VendorCompanyHistoryTable open={vendorCompHitory.open} hide={HideVendorHistoryTabe} toast={props.toast} isManager={_roles.includes(2) ? loginObj.id : 0} companyname={vendorCompHitory.companyName} recruiter={vendorCompHitory.recruiter} />
        </Dialog>
    );
}